export default "__VITE_ASSET__Cttm8o3x__"